import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { styles } from './RankingsTitleStyles';
import moment from 'moment';

export default class RankingsTitle extends Component {
  render() {
    return (
        <div className={css(styles.titleWrapper)}>
          <h2 className={css(styles.appliancesTitle)}>{this.props.period.time_unit === 'week' ? `The Week's Summary` : `The Month's Summary`}</h2>
          <p className={css(styles.time)}>
            {this.props.period.time_unit === 'week' ?
              `${moment.unix(this.props.period.start_timestamp).format('dddd Do MMMM')} - Today` :
              `${moment.unix(this.props.period.start_timestamp).format('MMMM')}`
            }
          </p>
        </div>
    );
  }
}
